import { useRecoveryRequestMutation } from '@/shared/api-rtk'
import { email_pattern } from '@/shared/constants/common'
import { TOAST_ERROR } from '@/shared/constants/toastTypes'
import { useEffect, useRef, useState } from 'react'
import { Button, Form, InputGroup } from 'react-bootstrap'
import { submitForm } from '@/shared/actions/contact'
import { SITE_KEY_RECAPTCHA } from '@/shared/constants/linksApi'
import  ReCAPTCHA  from  "react-google-recaptcha";

const timerSec = 60

export const FormPasswordRecover = () => {
    const [email, setEmail] = useState('')
    const [empttyEmail, setEmptyEmail] = useState(true)
    const [isValid, setIsValid] = useState(false)
    const [isSend, setIsSend] = useState(false)
    const [timer, setTimer] = useState(0)
    const [trigger, setTrigger] = useState(false)
    const [isInit, setIsInit] = useState(true)
    const [onBlur, setOnBlur] = useState(false)
    const interval = useRef(null)

    const [recaptchaToken, setRecaptchaToken] = useState(null)

    const [postEmain, { isError, isLoading, isSuccess, data }] =
        useRecoveryRequestMutation()

    useEffect(() => {
        if (!trigger) return
        interval.current = setInterval(
            () => setTimer((state) => state - 1),
            1000
        )
        setTrigger(false)
    }, [trigger])

    useEffect(() => {
        if (timer <= 0) {
            setTimer(0)
            clearInterval(interval.current)
        }
    }, [timer])

    useEffect(() => {
        if (!isError) return
        TOAST_ERROR(
            'Проблема на стороне сервера. Пожалуйста, обратитесь к администратору.'
        )
    }, [isError])

    useEffect(() => {
        return () => {
            clearInterval(interval.current)
        }
    }, [])

    const sendHandler = async (e) => {
        e.preventDefault()
        if (!isValid) return
        if (!email.length) {
            setEmptyEmail(true)
            return
        }
        try {
            if (!recaptchaToken) {
                TOAST_ERROR('Пройдите капчу!')
                return
            }

            const res = await submitForm(recaptchaToken)

            if (!res.success) {
                TOAST_ERROR(res.error)
                return
            }

            setRecaptchaToken(null)

            const respone = await postEmain({ email: email }).unwrap()
            if (respone.success) {
                setIsSend(true)
                setTimer(timerSec)
                setTrigger(true)
            } else {
                TOAST_ERROR(respone.error)
            }
        } catch (err) {
            console.error('error:', err);
            TOAST_ERROR('Проблема на стороне клиента. Пожалуйста, обратитесь к администратору.')
        }
    }

    const blurEmailHanlder = (e) => {
        setOnBlur(true)
        if (e.target.value) {
            setIsValid(email_pattern.test(e.target.value))
            setEmptyEmail(false)
        } else {
            setIsValid(false)
            setEmptyEmail(true)
        }
    }

    const changeEmailHandler = (e) => {
        setIsInit(false)
        setIsValid(email_pattern.test(e.target.value))
        setEmail(e.target.value)
        setEmptyEmail(!e.target.value)
    }

    const handleFocus = (e) => {
        setOnBlur(false)
    }

    return (
        <Form
            className={'FormAuth'}
            onSubmit={sendHandler}
            style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}
        >
            <InputGroup
                className={'input-control'}
                style={{ flexDirection: 'column', width: '100%' }}
            >
                <Form.Label htmlFor="email-recovery">E-Mail</Form.Label>
                <Form.Control
                    style={{ width: '100%' }}
                    id="email-recovery"
                    type={'email'}
                    placeholder={'Введите E-Mail'}
                    name={'email'}
                    value={email}
                    onChange={changeEmailHandler}
                    onBlur={blurEmailHanlder}
                    onFocus={handleFocus}
                    isInvalid={!isValid && onBlur && !isInit}
                />
                <Form.Control.Feedback type="invalid">
                    {!isValid &&
                        !isInit &&
                        !empttyEmail &&
                        onBlur &&
                        'Некорректный email'}
                    {empttyEmail && !isInit && onBlur && 'Введите email'}
                </Form.Control.Feedback>
            </InputGroup>
            <ReCAPTCHA
                size="normal"
                sitekey={SITE_KEY_RECAPTCHA}
                onChange={(token) => setRecaptchaToken(token)} 
                onErrored={() => setRecaptchaToken(null)} 
            />
            {isSuccess && data.success && <p>Проверьте свой почтовый ящик.</p>}
            {!!timer && <p>Повторная отправка возможна через: {timer} с.</p>}
            {!timer && (
                <Button
                    type="subbmit"
                    disabled={!isValid || empttyEmail || isLoading}
                >
                    {!isLoading
                        ? !isSend
                            ? 'Отправить'
                            : 'Отправить повторно'
                        : 'Загрузка...'}
                </Button>
            )}
        </Form>
    )
}
